import { isNode } from './environment';

/**
 * Isomorphic log function
 */
export function logger(level, message, ...metadata) {
  const isoLogger = isNode() ? global.logger : window.EDM.Venom.logger || console;
  isoLogger[level](message, ...metadata);
}
